// AUTO-GENERATED — do not edit manually.
// Run `pnpm sync-roles` to regenerate from the database.

export const AppPermissions = {
  prism: {
    /** Copy Permission Key — Can see and copy the JS constant path for permissions and roles */
    adminCopyPermissionKey: 'Admin.CopyPermissionKey',
    /** Manage Administration — Full admin capability including user/role management and data sync */
    adminManage: 'Admin.Manage',
    /** View Usage Logs — Ability to view request usage logs and metrics */
    adminUsageLog: 'Admin.UsageLog',
    /** Manage Data Scopes — Ability to create, edit, and assign attribute data scopes and view protected field groups */
    dataScopeManage: 'DataScope.Manage',
    /** Read Land Agreement Financials — Can view rent roll, billing schedule, and yield history for Land Agreement leases */
    landAgreementFinancialsRead: 'LandAgreementFinancials.Read',
    /** Read Market Value — Can read market value of an investment */
    marketValueRead: 'MarketValue.Read',
    /** Export Properties — Ability to export properties table to CSV or XLSX */
    propertiesExport: 'Properties.Export',
    // Added manually pending next 'pnpm sync-roles' run
    /** Country Summary — Ability to view Country Summary and use the Country Summary map action */
    countrySummary: 'Properties.CountrySummary',
    /** Properties.TableView */
    propertiesTableView: 'Properties.TableView',
    /** Read Portfolio Dashboard — Can view the org-wide properties portfolio dashboard */
    portfolioDashboardRead: 'Portfolio.DashboardRead',
    /** Query AI Chat — Can open and ask questions of the PRISM AI assistant */
    aiChatQuery: 'AiChat.Query',
  },
  prismInvestment: {
    /** Read Financials & Prices — Allows viewing sensitive transaction prices, purchase figures, IRR, COC, and property prices */
    financialsRead: 'Financials.Read',
    /** Foreign Property Viewer — Can View Foreign Properties */
    foreignPropertyViewer: 'ForeignProperty.Viewer',
    /** Cancel Transactions — Can cancel a transaction */
    transactionCancel: 'Transaction.Cancel',
    /** Change Health — Can change the health of a transaction */
    transactionChangeHealth: 'Transaction.ChangeHealth',
    /** Create Transactions — Can create new transactions */
    transactionCreate: 'Transaction.Create',
    /** Export Transactions — Ability to export transactions */
    transactionExport: 'Transaction.Export',
    /** Jarvis Integration — Can add or modify JarvisId and JarvisName data for a transaction */
    transactionJarvis: 'Transaction.Jarvis',
    /** Mark Mapped — Can mark a transaction as mapped */
    transactionMarkMapped: 'Transaction.MarkMapped',
    /** Qualify/Decline (CEO) — Qualify or decline transactions in the CEO role */
    transactionQualifyOrDeclineCeo: 'Transaction.QualifyOrDeclineCeo',
    /** Qualify/Decline (Operations) — Qualify or decline transactions in the Operations VP role */
    transactionQualifyOrDeclineOperations: 'Transaction.QualifyOrDeclineOperations',
    /** Read Transactions — Can view transactions */
    transactionRead: 'Transaction.Read',
    /** Submit Transactions — Can submit a transaction for approval */
    transactionSubmit: 'Transaction.Submit',
    /** Toggle Edit Lock — Can lock or unlock ability to edit a PrismTransaction */
    transactionToggleEditLock: 'Transaction.ToggleEditLock',
    /** Update Transactions — Can make updates to transactions */
    transactionUpdate: 'Transaction.Update',
    /** Update Snapshot — Can edit a PrismTransaction phase snapshot */
    transactionUpdateSnapshot: 'Transaction.UpdateSnapshot',
    /** Update COC — Can update Cost of Capital on a transaction */
    transactionUpdateCOC: 'Transaction.UpdateCOC',
    /** Update IRR — Can update Internal Rate of Return on a transaction */
    transactionUpdateIRR: 'Transaction.UpdateIRR',
    /** Write Price Types — Can create, update, and delete transaction price types */
    transactionPriceTypeWrite: 'TransactionPriceType.Write',
    /** View Transaction Reports */
    transactionReportRead: 'TransactionReport.Read',
    /** Read all transaction reports */
    transactionReportReadAll: 'TransactionReport.ReadAll',
    /** TransactionReport.ViewPrices — View Price column in transaction reports */
    transactionReportViewPrices: 'TransactionReport.ViewPrices',
    /** Approve Finance Lead — Can select and approve the finance lead on a transaction */
    transactionTeamApproveFinanceLead: 'TransactionTeam.ApproveFinanceLead',
    /** Approve Investment Analyst — Can select and approve the investment analyst on a transaction */
    transactionTeamApproveInvestmentAnalyst: 'TransactionTeam.ApproveInvestmentAnalyst',
    /** Approve Transaction Lead — Can select and approve the transaction lead */
    transactionTeamApproveTransactionLead: 'TransactionTeam.ApproveTransactionLead',
    /** Update Team Lead — Can update a transaction team lead */
    transactionTeamUpdateTransactionTeamLead: 'TransactionTeam.UpdateTransactionTeamLead',
    /** Edit Task Definitions — Can edit task templates (label, requiredness, milestone, phase) */
    transactionTaskEditTask: 'TransactionTask.EditTask',
    /** Edit Completed Task Data — Can edit the completion data (date, comments, custom fields) of an already-completed task */
    transactionTaskEditTaskData: 'TransactionTask.EditTaskData',
    /** Manage Users — Can manage users within the Investment app */
    userManage: 'User.Manage',
  },
  prismLand: {
    /** Land Test — test */
    landTest: 'Land.Test',
    /** Manage Users — Can manage users within the Land app */
    userManage: 'User.Manage',
  },
} as const;

type NestedValues<T> = T extends Record<string, infer V>
  ? V extends string ? V : NestedValues<V>
  : never;

/** Union of all known AppPermission key strings. */
export type AppPermissionKey = NestedValues<typeof AppPermissions>;
